import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Observable, of } from 'rxjs';

@Injectable()
export class ShelterNameResolver implements Resolve<any> {
  resolve(route: ActivatedRouteSnapshot): Observable<any> | Observable<never> {
    return of('FAKE HARDCODED SHELTER NAME');
  }
}
